<template>
  <div id="app_signup">
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <vue-element-loading :active="appLoading1" :is-full-screen="true" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showsnackbar" color="#00a972" right :timeout="timeout">
      {{msg}}
      <v-btn text @click="showsnackbar = false">
        <v-icon style="color:white;">mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-layout wrap justify-space-around>
      <v-flex xs12 md12 pa-8>
        <v-card style=" min-height:80vh;" outlined tile>
          <v-layout wrap pt-10>
            <v-flex xs12 md12 text-center>
              <span style="font-size:20px;font-weight:500;">Upload Supporting Documents</span>
            </v-flex>
          </v-layout>
          <v-layout wrap px-2 justify-center pt-3>
            <v-flex xs12 md4>
              <v-layout pb-5 wrap justify-center>
                <v-flex xs12 md6 text-center>
                  <span v-if="userType == 'Individual'">Individual Investor</span>
                  <span v-if="userType=='Company'">Company Account</span>
                  <v-progress-linear :value="100" color="#fb6b0b" height="2"></v-progress-linear>
                </v-flex>
                <v-flex xs12 md12 pt-2 text-center>
                  <span style="font-sizer:14px;font-weight:400;color:#a9a9a9">{{userEmail}}</span>
                </v-flex>
              </v-layout>
              <v-select
                :items="Countries"
                ref="country"
                v-model="country"
                item-text="country"
                item-value="country"
                :rules="[rules.required]"
                label="Country"
                color="#26af82"
              ></v-select>
              <v-select
                v-if="userType =='Company'"
                ref="registrationCountry"
                :items="Countries"
                item-text="country"
                item-value="country"
                v-model="registrationCountry"
                :rules="[rules.required]"
                label="Country of Incorporation"
                color="#26af82"
              ></v-select>
              <v-text-field
                v-if="userType =='Company'"
                ref="registrationNumber"
                v-model="registrationNumber"
                :rules="[rules.required]"
                label="Company Registration Number"
                color="#26af82"
                required
              ></v-text-field>
              <v-flex v-if="country || registrationCountry" xs12 md12 pt-5 text-center>
                <v-flex xs12 md12>
                  <v-select
                    v-if="userType =='Individual'"
                    ref="supportingDoc"
                    :items="supportingDocs"
                    v-model="supportingDoc"
                    :rules="[rules.required]"
                    label="Supporting Evidence"
                    color="#26af82"
                  ></v-select>
                </v-flex>
                <v-flex v-if="userType=='Individual'" pt-3 xs12 md12 text-center>
                  <v-text-field
                    ref="supDocNo"
                    v-model="supDocNo"
                    :rules="[rules.required]"
                    label="Supporting Evidence Number"
                    color="#26af82"
                    hint="Upload scanned copy of personal identification card (front and back)"
                    persistent-hint
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex v-if="userType =='Company'" pt-3>
                  <span
                    style="font-size:12px;font-weight:400;color:#a9a9a9;"
                  >Upload Scaned copy of Company registration details</span>
                </v-flex>
                <v-layout wrap pt-3 justify-space-around>
                  <v-flex xs12 md5 pt-2 text-center>
                    <v-layout wrap justify-center>
                      <v-flex xs12 sm12 md12>
                        <span style="font-size:12px;">Front</span>
                      </v-flex>
                      <v-flex py-2 xs12 sm12 md12>
                        <v-btn
                          rounded
                          small
                          :ripple="false"
                          id="sup_front"
                          class="text-capitalize"
                          outlined
                          color="#26af82"
                          width="120"
                          @click="$refs.uploadsupfrnt.click()"
                        >
                          Upload
                          <v-img
                            src="../../assets/icons/upload.png"
                            aspect-ratio="1"
                            contain
                            height="20px"
                          >
                            <template v-slot:placeholder>
                              <v-row class="fill-height ma-0" align="center" justify="center">
                                <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </v-btn>
                        <input
                          v-show="false"
                          ref="uploadsupfrnt"
                          accept="image/*"
                          type="file"
                          @change="uploadsupfrnt"
                        />
                      </v-flex>
                      <v-flex
                        xs12
                        sm12
                        md12
                        style="height:150px;background-color:#f5f5f5;"
                        align="center"
                        text-center
                      >
                        <v-img
                          v-if="supdocfrntimg"
                          id="supFront"
                          :src="supdocfrntimg"
                          aspect-ratio="1"
                          contain
                          height="100%"
                        >
                          <template v-slot:placeholder>
                            <v-row class="fill-height ma-0" align="center" justify="center">
                              <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>

                        <v-img
                          v-else-if="supDocFront"
                          :src="baseURL+'/u/'+supDocFront"
                          id="proPic"
                          aspect-ratio="1"
                          contain
                          height="100%"
                        >
                          <template v-slot:placeholder>
                            <v-row class="fill-height ma-0" align="center" justify="center">
                              <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 md5 pt-2 text-center>
                    <v-layout wrap justify-center>
                      <v-flex xs12 sm12 md12>
                        <span style="font-size:12px;">Back</span>
                      </v-flex>
                      <v-flex py-2 xs12 sm12 md12>
                        <v-btn
                          rounded
                          small
                          dark
                          id="sup_back"
                          :ripple="false"
                          class="text-capitalize"
                          outlined
                          color="#26af82"
                          width="120"
                          @click="$refs.uploadsupback.click()"
                        >
                          Upload
                          <v-img
                            src="../../assets/icons/upload.png"
                            aspect-ratio="1"
                            contain
                            height="20px"
                          >
                            <template v-slot:placeholder>
                              <v-row class="fill-height ma-0" align="center" justify="center">
                                <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </v-btn>
                        <input
                          v-show="false"
                          ref="uploadsupback"
                          :rules="[rules.required]"
                          accept="image/*"
                          type="file"
                          @change="uploadsupback"
                        />
                      </v-flex>
                      <v-flex
                        xs12
                        sm12
                        md12
                        style="height:150px;background-color:#f5f5f5;"
                        align="center"
                        text-center
                      >
                        <v-img
                          v-if="supdocbackimg"
                          id="supBack"
                          :src="supdocbackimg"
                          aspect-ratio="1"
                          contain
                          height="100%"
                        >
                          <template v-slot:placeholder>
                            <v-row class="fill-height ma-0" align="center" justify="center">
                              <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>

                        <v-img
                          v-else-if="supDocBack"
                          :src="baseURL+'/u/'+supDocBack"
                          id="proPic"
                          aspect-ratio="1"
                          contain
                          height="100%"
                        >
                          <template v-slot:placeholder>
                            <v-row class="fill-height ma-0" align="center" justify="center">
                              <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>

                <v-layout v-if="userType == 'Individual'" wrap justify-center>
                  <v-flex xs12 md12 text-center>
                    <v-checkbox
                      ref="formConfirmation"
                      v-model="formConfirmation"
                      :rules="[rules.required]"
                      :ripple="false"
                      color="#26af82"
                      class="confbox"
                      label="Please Confirm that you are accredited, qualified or professional investor (as defined in your juristication of residence)"
                      required
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs12 md12 pt-2 pl-2 text-left>
                    <v-file-input
                      ref="accdoc"
                      label="Accreditation Note"
                      show-size
                      color="#26af82"
                      v-model="accdoc"
                      :rules="[rules.required,rules.filesize]"
                      required
                    ></v-file-input>
                  </v-flex>
                </v-layout>

                <v-layout pt-5 v-if="userType == 'Company'" wrap justify-center>
                  <v-flex xs12 md12 text-center>
                    <v-checkbox
                      ref="formConfirmation"
                      v-model="formConfirmation"
                      :rules="[rules.required]"
                      :ripple="false"
                      color="#26af82"
                      class="confbox"
                      label="I agree to ecosystem investor platform Terms of Service and Privacy Policy"
                      required
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-flex>
            <v-flex xs12 md12 pa-10 text-center>
              <br />
              <v-btn
                width="220"
                class="text-capitalize"
                :ripple="false"
                color="#26af82"
                dark
                small
                @click="submit"
              >Submit</v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      country: null,
      supDocNo: null,
      formConfirmation: false,

      registrationCountry: null,
      registrationNumber: null,

      accdoc: null,
      Countries: [],
      supportingDocs: [],
      supportingDoc: null,
      winStep: 0,
      rules: {
        required: value => !!value || "Required",
        name: value => {
          const pattern = /^[A-Za-z ]*$/;
          return pattern.test(value) || "Invalid Name";
        },
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid Mail ID";
        },
        filesize: value =>
          !value ||
          value.size < 5000000 ||
          "Document size should be less than 5 MB!"
      },
      msg: null,
      formHasErrors: true,
      userEmail: localStorage.getItem("email"),
      userType: localStorage.getItem("userType"),

      appLoading: false,
      appLoading1: false,
      showsnackbar: false,
      timeout: 5000,
      ServerError: false,
      supdocfrntimg: null,
      supdocbackimg: null,
      supdocfrntname: null,
      supdocbackname: null,
      supdocfrnt: null,
      supdocback: null,
      supfrntsts: false,
      supbacksts: false,
      profilePic: null,
      supDocFront: null,
      supDocBack: null,
      accreditationDocument: null
    };
  },
  computed: {
    form() {
      return {
        country: this.country,
        supportingDoc: this.supportingDoc,
        supDocNo: this.supDocNo,
        formConfirmation: this.formConfirmation,
        accdoc: this.accdoc
      };
    },
    form2() {
      return {
        registrationCountry: this.registrationCountry,
        registrationNumber: this.registrationNumber,
        formConfirmation: this.formConfirmation
      };
    }
  },
  watch: {
    country: function() {
      if (this.country) {
        axios({
          method: "GET",
          url: "/country/getbyname",
          params: {
            country: this.country
          }
        })
          .then(response => {
            this.supportingDocs = response.data.data.evidence;
          })
          .catch(err => {
            this.msg = err;
            this.ServerError = true;
          });
      }
    }
  },
  beforeMount() {
    this.getCountries();
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading1 = true;
      axios({
        method: "GET",
        url: "/user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          if (response.data.progress > 0) {
            this.userType = response.data.data.type;
            if (response.data.data.type == "Individual") {
              if (response.data.data.individual.supportingEvidenceName)
                this.supportingDoc =
                  response.data.data.individual.supportingEvidenceName;
              if (response.data.data.individual.supportingEvidence)
                this.supDocNo =
                  response.data.data.individual.supportingEvidence;
              for (var i = 0; i < response.data.data.documents.length; i++) {
                if (
                  response.data.data.documents[i].type == "Supporting Document"
                ) {
                  if (response.data.data.documents[i].remark == "front") {
                    this.supDocFront = response.data.data.documents[i].filename;
                  }
                  if (response.data.data.documents[i].remark == "back") {
                    this.supDocBack = response.data.data.documents[i].filename;
                  }
                }

                if (
                  response.data.data.documents[i].type == "Accreditation Doc"
                ) {
                  // ////////////////////////////////////////////////////////////////////////////
                  this.accreditationDocument =
                    response.data.data.documents[i].originalname;
                }
              }
            } else if (response.data.data.type == "Company") {
              if (response.data.data.company.registrationCountry)
                this.registrationCountry =
                  response.data.data.company.registrationCountry;
              if (response.data.data.company.registrationNumber)
                this.registrationNumber =
                  response.data.data.company.registrationNumber;
              if (response.data.data.company.email)
                this.mailId = response.data.data.company.email;
            }
            if (response.data.data.address.country)
              this.country = response.data.data.address.country;
            this.formConfirmation = true;
          }
          this.appLoading1 = false;
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    },
    getCountries() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/country/getlist"
      })
        .then(response => {
          this.appLoading = false;
          this.Countries = response.data.data;
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    },
    uploadsupfrnt(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      if (files[0].size > 5242880) {
        this.msg = "File Should be less than 5MB";
        this.showsnackbar = true;
        return;
      }
      this.supdocfrnt = e.target.files[0];
      this.supdocfrntname = e.target.files[0].name;
      var reader = new FileReader();
      reader.onload = e => {
        this.supdocfrntimg = e.target.result;
      };
      this.supfrntsts = true;
      reader.readAsDataURL(files[0]);
    },
    uploadsupback(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      if (files[0].size > 5242880) {
        this.msg = "File Should be less than 5MB";
        this.showsnackbar = true;
        return;
      }
      this.supdocback = e.target.files[0];
      this.supdocbackname = e.target.files[0].name;
      var reader = new FileReader();
      reader.onload = e => {
        this.supdocbackimg = e.target.result;
      };
      this.supbacksts = true;
      reader.readAsDataURL(files[0]);
    },
    submit() {
      this.formHasErrors = false;
      if (!this.supfrntsts && !this.supDocFront) {
        this.formHasErrors = true;
        this.msg = "Upload Supporting Document";
        this.showsnackbar = true;
        return;
      }
      if (!this.supbacksts && !this.supDocBack) {
        this.formHasErrors = true;
        this.msg = "Upload Supporting Document";
        this.showsnackbar = true;
        return;
      }
      if (this.userType == "Individual") {
        Object.keys(this.form).forEach(f => {
          if (!this.form[f]) this.formHasErrors = true;
          if (!this.$refs[f].validate(true)) this.formHasErrors = true;
        });
        if (!this.accdoc || this.accdoc.size > 5242880) {
          this.formHasErrors = true;
          this.msg = "Upload Accreditation Note";
          this.showsnackbar = true;
          return;
        }
      }
      if (this.userType == "Company") {
        Object.keys(this.form2).forEach(f => {
          if (!this.form2[f]) this.formHasErrors = true;
          if (!this.$refs[f].validate(true)) this.formHasErrors = true;
        });
      }
      if (!this.formConfirmation) this.formHasErrors = true;
      this.appRegister();
    },
    appRegister() {
      if (!this.formHasErrors) {
        var prodata = {};
        prodata["id"] = localStorage.getItem("userId");
        prodata["country"] = this.country;
        prodata["supportingEvidence"] = this.supDocNo;
        prodata["supportingEvidenceName"] = this.supportingDoc;
        prodata["termsAndPrivacyAgreement"] = this.formConfirmation;
        if (this.userType == "Individual") {
          prodata["isAccreditated"] = true;
        }
        if (this.userType == "Company") {
          prodata["isAccreditated"] = false;
          prodata["companyemail"] = this.mailId;
          prodata["registrationCountry"] = this.registrationCountry;
          prodata["registrationNumber"] = this.registrationNumber;
        }
        this.appLoading = true;
        axios({
          method: "POST",
          url: "/user/Edit",
          headers: {
            "x-auth-token": localStorage.getItem("token")
          },
          data: prodata
        })
          .then(response => {
            this.appLoading = false;
            if (response.data.status) {
              this.uploadCheck();
            } else {
              this.msg = response.data.msg;
              this.appLoading = false;
            }
          })
          .catch(err => {
            this.msg = err;
            this.ServerError = true;
          });
      } else {
        this.msg = "Please Validate Input";
        this.showsnackbar = true;
        this.appLoading = false;
      }
    },
    uploadCheck() {
      this.appLoading = true;
      var data = {};

      if (this.supfrntsts || this.supbacksts) {
        data["type1"] = "Supporting Document";
      }
      if (this.accdoc) {
        data["type2"] = "Accreditation Doc";
      }
      axios({
        method: "POST",
        url: "/user/replacedocument",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        },
        data: data
      })
        .then(response => {
          if (response.data.status) {
            this.uploadDocs();
          } else {
            this.uploadDocs();
          }
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    },
    uploadDocs() {
      if (this.supdocfrnt && this.supdocback) {
        let formData = new FormData();
        formData.append("front", this.supdocfrnt);
        formData.append("back", this.supdocback);
        formData.append("frontname", this.supdocfrntname);
        formData.append("backname", this.supdocbackname);
        formData.append("type", "Supporting Document");
        formData.append("completeprofile", true);
        if (this.userType == "Individual") {
          formData.append("name", this.supportingDoc);
        }
        if (this.userType == "Company") {
          formData.append("name", "Company Registration Doc");
        }
        // formData.append("name", "aadhar");
        this.appLoading = true;
        axios({
          method: "POST",
          url: "/user/upload/allsupportdocs",
          headers: {
            "Content-Type": "multipart/form-data",
            "x-auth-token": localStorage.getItem("token")
          },
          data: formData
        })
          .then(response => {
            this.appLoading = false;
            if (this.userType == "Individual") {
              this.uploadAccDocs();
            } else {
              this.$router.push("/RegistrationAcknowledgement");
            }
            this.msg = response.data;
            this.msg = null;
          })
          .catch(err => {
            this.msg = err;
            this.ServerError = true;
          });
      } else {
        this.uploadAccDocs();
      }
    },
    uploadAccDocs() {
      if (this.accdoc) {
        this.appLoading = true;
        var accreditationDoc = null;
        accreditationDoc = new FormData();
        accreditationDoc.append("doc", this.accdoc);
        accreditationDoc.append("name", "Accreditation Document");
        accreditationDoc.append("type", "Accreditation Doc");
        accreditationDoc.append("remark", "Accreditation Doc");

        axios({
          method: "POST",
          url: "/user/Uploaddocument",
          headers: {
            "Content-Type": "multipart/form-data",
            "x-auth-token": localStorage.getItem("token")
          },
          data: accreditationDoc
        })
          .then(response => {
            this.msg = response.data.msg;
            if (response.data.status) {
              this.appLoading = false;
              this.$router.push("/RegistrationAcknowledgement");
            } else {
              this.appLoading = false;
            }
          })
          .catch(err => {
            this.msg = err;
            this.ServerError = true;
          });
      } else {
        this.$router.push("/RegistrationAcknowledgement");
      }
    }
  }
};
</script>
<style scoped>
#app_signup {
  background-image: url("../../assets/home_header.png");
  background-repeat: no-repeat;
  background-size: cover;
  color: white;
}

.confbox >>> label {
  color: black !important;
  font-size: 11px !important;
  line-height: 12px !important;
}
.upload-btn-wrapper {
  position: relative;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}
</style>